import { createSelector } from '@reduxjs/toolkit';
import { AppState } from 'store';
import { IAuthState } from './auth.interface';

export const authStateSelector = ({ auth }: AppState): IAuthState => auth;

export const getIsLoggedInSelector = createSelector(authStateSelector, ({ isLoggedIn }) => isLoggedIn);

export const getChosenProjectSelector = createSelector(authStateSelector, ({ chosenProject }) => chosenProject);

export const getIsDirtySelector = createSelector(authStateSelector, ({ isDirty }) => isDirty);

export const getKenticoProjectNameSelector = createSelector(authStateSelector, ({ projectName }) => projectName);

export const getProjectIdSelector = createSelector(authStateSelector, ({ projectId }) => projectId);

export const getProjectPrefixSelector = createSelector(authStateSelector, ({ projectPrefix }) => projectPrefix);

export const getAllowDueDateChangeSelector = createSelector(
  authStateSelector,
  ({ allowDueDateChange }) => allowDueDateChange,
);

export const getDaysToDefaultDueDateSelector = createSelector(
  authStateSelector,
  ({ daysToDefaultDueDate }) => daysToDefaultDueDate,
);
